import {ButtonActionEnum, ButtonTypeEnum, IspColoursEnum} from '@i-supplier/angular-shared-module';
import {AuthenticationService} from '../core/services/authentication.service';
import {TranslatorService} from '../core/services/translator.service';
import {CountryISO, SearchCountryField} from 'ngx-intl-tel-input-gg';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {SignupEnum} from '../shared/enums/Signup.enum';
import {TranslateService} from '@ngx-translate/core';
import {regex} from '../shared/regex/form.regex';
import {ToastrService} from 'ngx-toastr';
import {Component} from '@angular/core';
import {Subscription} from 'rxjs';

@Component({
  selector: 'app-dashboard',
  templateUrl: 'signup.component.html',
  styleUrls: ['./signup.component.scss'],
})
export class SignupComponent {
  protected readonly ButtonActionEnum = ButtonActionEnum;
  protected readonly ButtonTypeEnum = ButtonTypeEnum;
  protected readonly IspColoursEnum = IspColoursEnum;
  SUPPLIER_TYPE = SignupEnum.SUPPLIER;
  FREELANCE_TYPE = SignupEnum.FREELANCE;
  formGroup: FormGroup;
  // phone number input variables
  preferredCountries: CountryISO[] = [CountryISO.France];
  searchCountryField = SearchCountryField;
  countryISO = CountryISO;
  loaders: { [key: string]: boolean } = {};
  headerMsg: string;
  bodyMsg: string;
  endMsg: string;
  private subscriptions: Subscription[] = [];
  // languages
  languages: any;
  selectedLanguage: any;

  constructor(
    private _formBuilder: FormBuilder,
    private toastrService: ToastrService,
    private translateService: TranslateService,
    private translatorService: TranslatorService,
    private authenticationService: AuthenticationService,
  ) {
    this.loaders['isSuccess'] = false;
    this.formGroup = this._formBuilder.group({
      name: [null, [Validators.required, Validators.pattern(regex.companyName), Validators.maxLength(75)]],
      type: [this.FREELANCE_TYPE, [Validators.required]],
      origin: [null, [Validators.required]],
      registrationNumber: [null],
      incorporationNumber: [null],
      administrativeManager: this._formBuilder.group({
        firstName: [null, [Validators.required, Validators.pattern(regex.firstName), Validators.maxLength(50)]],
        lastName: [null, [Validators.required, Validators.pattern(regex.lastName), Validators.maxLength(50)]],
        email: [null, [Validators.required, Validators.pattern(regex.email), Validators.maxLength(100)]],
        phoneNumber: [null, [Validators.required]]
      })
    });
    this.loaders['companySignup'] = false;
    this.languages = this.translatorService.languages;
    this.selectedLanguage = this.translatorService.getLanguage();
    this.changeLang(this.selectedLanguage);
    this.subscribeListeners();
  }

  subscribeListeners() {
    this.subscriptions.push(this.formGroup.get('origin').valueChanges.subscribe(() => {
      const reg = this.formGroup.get('registrationNumber');
      const inc = this.formGroup.get('incorporationNumber');
      if (this.isOverseasFrance) {
        reg.setValidators(null);
        inc.setValidators([Validators.required, Validators.pattern(regex.registrationNumber), Validators.minLength(14), Validators.maxLength(14)]);
      } else {
        reg.setValidators([Validators.required, Validators.maxLength(50)]);
        inc.setValidators([Validators.maxLength(50)]);
      }
      [reg, inc].forEach(c => {
        c.updateValueAndValidity({emitEvent: false});
        c.markAsDirty();
      });
    }));
  }

  changeCompanyType(companyType: string) {
    this.formGroup.patchValue({'type': companyType});
  }

  changeLang(event: any) {
    this.translatorService.changeLang(event);
  }

  createCompanyFormSubmit(): void {
    this.loaders['companySignup'] = true;
    this.authenticationService.createCompany(this.formGroup.value).subscribe({
      next: () => {
        this.loaders['isSuccess'] = true;
        this.headerMsg = this.translateService.instant('Signup.success.account_created');
        this.bodyMsg = this.translateService.instant('Signup.success.creation_success_message');
        this.endMsg = this.translateService.instant('Signup.success.seconds');
      },
      error: () => {
        this.loaders['companySignup'] = false;
        this.toastrService.error(this.translateService.instant('global.feedback.unavailable-enterprise-identity'));
      }
    });
  }

  get isOverseasFrance(): boolean {
    return this.formGroup.get('origin').value?.isRegulatoryEnterprise;
  }
}
